export class JourneyListUtils {
    isOutOfBoxExperienceEnabled: boolean;
    isSmartActions: boolean;

    private colw(saOob: number, saNonOob: number, oob: number, nonOob: number): string {
        const n = this.isSmartActions
            ? (this.isOutOfBoxExperienceEnabled ? saOob : saNonOob)
            : (this.isOutOfBoxExperienceEnabled ? oob : nonOob);
        return n ? `colw-${n}` : '';
    }

    get columnNameClassWidth()         { return this.colw(19, 20, 14, 16); }
    get columnProductGroupClassWidth() { return this.colw(14, 15, 11, 14); }
    get columnCreatedByClassWidth()    { return this.colw(14, 17, 11, 14); }
    get columnCampaignClassWidth()     { return this.colw( 9, 11,  8, 10); }
    get columnDateCreatedClassWidth()  { return this.colw( 8, 11,  8, 10); }
    get columnDateModifiedClassWidth() { return this.colw( 8, 11,  8, 10); }
    get columnStatusClassWidth()       { return this.colw( 7,  8, 10, 12); }
    get columnActionIconsClassWidth()  { return this.colw( 0,  0, 10, 13); }
}
